var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup124044({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_124044",
    "data-name": "Group 124044",
    transform: "translate(-305 -247)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_267",
    "data-name": "Ellipse 267",
    cx: 14,
    cy: 14,
    r: 14,
    transform: "translate(305 247)",
    fill: "#1b4a83"
  }), /*#__PURE__*/React.createElement("g", {
    id: "interview-02",
    transform: "translate(310.966 253.784)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20544",
    "data-name": "Path 20544",
    d: "M.011,23.1c.374-.592.735-1.159,1.095-1.733a5.017,5.017,0,0,1-.781-1.334A4.8,4.8,0,1,1,2.682,22.61a.5.5,0,0,0-.3-.025c-.735.157-1.466.321-2.2.485-.046.011-.1.014-.171.029Zm5.21-3.726v-.984A1.47,1.47,0,0,0,4.6,15.518,1.448,1.448,0,0,0,3.36,16.958h.777c.014-.068.029-.132.046-.2a.666.666,0,1,1,.667.87c-.25.021-.417.136-.424.342-.014.46,0,.92,0,1.387a.906.906,0,0,1,.111.007h.688Zm.132,1.205a.533.533,0,1,0-.531.528.54.54,0,0,0,.531-.528Z",
    transform: "translate(0 -8.678)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20545",
    "data-name": "Path 20545",
    d: "M18.606,4.722a2.184,2.184,0,0,0-.314-.118c-.182-.032-.2-.139-.182-.3A4.757,4.757,0,0,1,21.669.161,4.825,4.825,0,0,1,27.66,4.115a4.659,4.659,0,0,1-.838,3.477.2.2,0,0,0-.007.275c.278.424.546.852.817,1.28a.283.283,0,0,1-.324.453c-.688-.157-1.38-.31-2.068-.456a.542.542,0,0,0-.317.036,4.832,4.832,0,0,1-2.953.349c-.118-.021-.157-.064-.157-.182s-.018-.253-.029-.389c.242.036.471.078.7.1a4.078,4.078,0,0,0,2.268-.4.735.735,0,0,1,.528-.057c.513.121,1.031.232,1.587.357-.061-.1-.1-.164-.143-.232-.164-.257-.328-.517-.492-.774-.146-.228-.143-.282.021-.489A4.274,4.274,0,1,0,18.688,4.08c-.036.207-.05.417-.075.645Z",
    transform: "translate(-11.648 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20546",
    "data-name": "Path 20546",
    d: "M29.8,8.7H25.54V7.92H29.8Z",
    transform: "translate(-16.432 -5.092)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20547",
    "data-name": "Path 20547",
    d: "M25.54,13.181V12.4H29.8v.781Z",
    transform: "translate(-16.432 -7.974)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20548",
    "data-name": "Path 20548",
    d: "M28.55,16.89h3.188v.781H28.55Z",
    transform: "translate(-18.369 -10.863)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup124044);
export default __webpack_public_path__ + "static/media/Group 124044.127367e491c15a3e45259b8639325182.svg";
export { ForwardRef as ReactComponent };